import React, { lazy } from 'react';

import { ServiceNotAvailableState } from '@lumapps/lumx-states/components/ServiceNotAvailableState';
import { Suspense } from '@lumapps/lumx-suspense/components/Suspense';
import { LoadingState } from '@lumapps/micro-apps/components/AdaptiveCard/LoadingState';

import { UploadMediaIntegratedProps } from './UploadMediaIntegrated';

const LazyUploadMediaIntegrated = lazy(
    () =>
        import(
            /* webpackChunkName: 'upload-media-lumapps-component' */
            './UploadMediaIntegrated'
        ),
);

export const UploadMediaIntegrated: React.FC<UploadMediaIntegratedProps> = (props) => (
    <Suspense loadingFallback={<LoadingState />} errorFallback={<ServiceNotAvailableState />}>
        <LazyUploadMediaIntegrated {...props} />
    </Suspense>
);
